<template>
  <div>
    <Main>
      <div class="mt-6 space-y-2 pb-6">
        <StudentItem
          v-for="(item, index) in suggestedStudents"
          :key="index"
          :item="item"
          :selected="item.dbId == selected"
          :showInternalId="user.role === 'operations'"
          :caller="$options.name"
          @changeSelected="selected = $event"
        />
      </div>
      <div class="modal-footer">
        <b-button v-if="selected != -1" variant="outline-success" @click="onEdit()">Edit this student instead</b-button>
        <b-button v-else variant="outline-secondary disabled">Edit this student instead</b-button>
        <b-button variant="outline-danger" @click="ignoreSuggestions()">Ignore</b-button>
      </div>
    </Main>
  </div>
</template>

<script>
import FieldsDef from './FieldsDef.js'
import user from '../../services/user/user.js'
import StudentItem from '../../components/items/StudentItem.vue'
import Main from '../../components/Main.vue'

export default {
  components: {
    StudentItem,
    Main,
  },
  props: {
    suggestedStudents: [],
  },
  name: 'SuggestedStudentForm',
  data() {
    return {
      user: {},
      fields: FieldsDef,
      transProps: {
        // Transition name
        name: 'flip-list'
      },
      selected: -1,
    }
  },
  methods: {
    ignoreSuggestions() {
      this.$emit('ignoreSuggestions', this.suggestedStudents)
      //this.$bvModal.hide('suggested-student-modal')
      //this.$refs['suggested-student-modal'].hide()
    },
    onEdit() {
      this.$emit('edit', this.selected)
    },
  },
  computed: {
    visibleFields() {
      return this.fields.filter(field => field.visible)
    }
  },
  async created() {
    this.user = await user.get()
  }
}
</script>

<style>
#SuggestedStudentForm {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 20px;
}
table#main-table .flip-list-move {
  transition: transform 0.5s;
}
</style>